import PageHeader from "@/components/PageHeader";
import { Hotel } from "lucide-react";

export default function HotelAccommodation() {
  return (
    <div data-testid="hotel-page">
      <PageHeader eyebrow="International Services" title="Hotel Accommodation"
        subtitle="Coordinate stays for patients and companions during their treatment window." />
      <div className="bg-white border border-[#E8E6E1] rounded-2xl p-12 text-center">
        <Hotel size={36} className="mx-auto text-[#8E9992] mb-3" />
        <div className="text-lg font-semibold text-[#2A332C] mb-1">Coming soon</div>
        <div className="text-sm text-[#8E9992] max-w-md mx-auto">
          Hotel partners, room blocking, rate cards and check-in coordination will land in the next release.
          Track patient accommodation needs from the travel details on each visa request in the meantime.
        </div>
      </div>
    </div>
  );
}
